import React from "react";
import { H2 } from "../../../../ui/style";
import { __ } from '@wordpress/i18n';

const BusinessLogo = () => {
	return (
		<>
			<H2>{__('Choose Your Logo', 'astra-sites')}</H2>
		</>
	);
};

export default BusinessLogo;
